import React, { useId, useState } from 'react';
import styles from './Features.module.css';

const FeatureFaqAccordion = ({ items }) => {
  const baseId = useId();
  const [openIds, setOpenIds] = useState(() => new Set());

  const toggleItem = (index) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  return (
    <div className={styles.faqList}>
      {items.map((item, index) => {
        const isOpen = openIds.has(index);
        const panelId = `${baseId}-panel-${index}`;
        const triggerId = `${baseId}-trigger-${index}`;

        return (
          <div
            key={item.question}
            className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ''}`}
          >
            <button
              type="button"
              id={triggerId}
              className={styles.faqTrigger}
              onClick={() => toggleItem(index)}
              aria-expanded={isOpen}
              aria-controls={panelId}
            >
              <span className={styles.faqQuestion}>{item.question}</span>
              <span className={`${styles.faqChevron} ${isOpen ? styles.faqChevronOpen : ''}`} aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </span>
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={triggerId}
              className={`${styles.faqPanel} ${isOpen ? styles.faqPanelOpen : ''}`}
              hidden={!isOpen}
            >
              <div className={styles.faqAnswer}>{item.answer}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeatureFaqAccordion;
